import(/* webpackMode: "eager" */ "/home/w3era/w3eraacademy_nextjsapp/node_modules/next/dist/client/image-component.js");
;
import(/* webpackMode: "eager" */ "/home/w3era/w3eraacademy_nextjsapp/node_modules/next/dist/client/link.js");
